// extracted by mini-css-extract-plugin
export default {"warning":"warning_warning__RjPv+","icon":"warning_icon__0rchA"};